import React, { useEffect } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { FadeIn } from '../components/FadeIn';
import { useModals } from '../contexts/ModalContext';
import { ShieldCheckIcon, TruckIcon, CheckCircleIcon, BatteryChargingIcon, MapPinIcon, CalendarIcon, ShoppingCartIcon } from 'lucide-react';
const EQUIPMENT = [{
  id: 1,
  name: 'Pride Go-Go Sport 4-Wheel Mobility Scooter',
  category: 'Mobility',
  daily: '$35',
  weekly: '$150',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Capacity: 325 lbs', 'Extra Battery Option']
}, {
  id: 2,
  name: 'Lightweight Transport Wheelchair',
  category: 'Mobility',
  daily: '$15',
  weekly: '$60',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Foldable', 'Trunk-Friendly']
}, {
  id: 3,
  name: 'Steerable Knee Scooter / Walker',
  category: 'Mobility',
  daily: '$20',
  weekly: '$80',
  image: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=400&auto=format&fit=crop',
  badges: ['Orthopedic Support', 'Adjustable']
}, {
  id: 4,
  name: 'Premium Double Stroller',
  category: 'Baby Gear',
  daily: '$15',
  weekly: '$65',
  image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400&auto=format&fit=crop',
  badges: ['RDU Airport Pickup', 'Sanitized']
}, {
  id: 5,
  name: 'Travel Crib / Playard',
  category: 'Baby Gear',
  daily: '$10',
  weekly: '$45',
  image: 'https://images.unsplash.com/photo-1519689680058-324335c77eba?w=400&auto=format&fit=crop',
  badges: ['Sanitized', 'Includes Sheet']
}];
export function EquipmentRentals() {
  const {
    openModal
  } = useModals();
  useEffect(() => {
    document.title = "Medical & Mobility Equipment Rentals | Care Nomad";
  }, []);
  return <div className="min-h-screen w-full bg-gray-50 flex flex-col" data-id="element-1229" data-mp="39e11byde7007">
      <Navbar data-id="element-1230" data-mp="16rnazgazfdhd" />
      
      <main className="flex-1" data-id="element-1231" data-mp="16r3rvw9lij1r">
        {/* Hero Section */}
        <section className="w-full relative py-16 lg:py-24 flex items-center justify-center min-h-[60vh]" data-id="element-1232" data-mp="1bkos7uynvp44">
          <div className="absolute inset-0 z-0" data-id="element-1233" data-mp="xtti6fcff1yy">
            <img src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?w=1600&auto=format&fit=crop" alt="Equipment Rentals Background" className="w-full h-full object-cover" data-id="element-1234" data-mp="11tu56odlclhm" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a2332]/95 to-[#1a2332]/70" data-id="element-1235" data-mp="1phv4r7sskrkw"></div>
          </div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full" data-id="element-1236" data-mp="1gj9qhoucrypx">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1237" data-mp="1li2zb3yp31jr">
              <div data-id="element-1238" data-mp="1ljxhwbmhuhko">
                <FadeIn direction="up" data-id="element-1239" data-mp="544bbld1c7pf">
                  <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-1240" data-mp="531phrukkvgd">
                    Mobility Scooters, Wheelchairs & Baby Gear <span className="text-[#007a87]" data-id="element-1241" data-mp="1ldujoe8xj3m">Delivered to Your Door</span>
                  </h1>
                  <p className="text-lg sm:text-xl text-white/90 mb-8 leading-relaxed font-medium" data-id="element-1242" data-mp="3tqhg8nap5x4j">
                    White-glove delivery across Raleigh, Durham, Chapel Hill, and Charlotte. Hospital-grade sanitized mobility equipment, strollers, and travel cribs delivered to hotels, homes, or RDU Airport.
                  </p>
                  
                  <div className="flex flex-wrap gap-4 text-sm font-medium text-white/80 mb-8" data-id="element-1243" data-mp="3eyqudhk4txjh">
                    <span className="flex items-center gap-1.5" data-id="element-1244" data-mp="39znmzqgojf8c"><TruckIcon className="w-4 h-4 text-green-400" data-id="element-1245" data-mp="3or4t01fwyo1f" /> Same-Day Delivery Available</span>
                    <span className="flex items-center gap-1.5" data-id="element-1246" data-mp="3jzmtzixgaxj3"><ShieldCheckIcon className="w-4 h-4 text-green-400" data-id="element-1247" data-mp="3jyljpgo9ef2f" /> 100% Hospital-Grade Disinfected</span>
                    <span className="flex items-center gap-1.5" data-id="element-1248" data-mp="2w7zahm2iqoqu"><BatteryChargingIcon className="w-4 h-4 text-green-400" data-id="element-1249" data-mp="2rc0qsbs4xuwr" /> Pre-Charged Spare Batteries Included</span>
                    <span className="flex items-center gap-1.5" data-id="element-1250" data-mp="1ul5b1n6va8e8"><CheckCircleIcon className="w-4 h-4 text-green-400" data-id="element-1251" data-mp="1ziyi0ifzv6fk" /> Partnered with Cloud of Goods</span>
                  </div>
                </FadeIn>
              </div>

              {/* Delivery Location Selector */}
              <FadeIn direction="left" delay={0.2} data-id="element-1252" data-mp="28bs9de8ptw9s">
                <div className="bg-white rounded-3xl p-8 shadow-2xl border border-gray-100" data-id="element-1253" data-mp="28dd6nbmeztbc">
                  <h3 className="text-2xl font-bold text-[#1a2332] mb-6" data-id="element-1254" data-mp="2da3jlq2xa8sj">Check Availability & Delivery</h3>
                  <form className="space-y-5" onSubmit={e => {
                  e.preventDefault();
                  openModal('rental');
                }} data-id="element-1255" data-mp="2ibj7rr0ecvf5">
                    <div data-id="element-1256" data-mp="2n6opedmrnnxf">
                      <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-1257" data-mp="2ramrmx7e1eup">Delivery Location</label>
                      <div className="relative" data-id="element-1258" data-mp="svjtxwlu2ht6">
                        <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1259" data-mp="swuvdprt3dh4" />
                        <select className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none bg-white" data-id="element-1260" data-mp="pckolahk6zgc">
                          <option data-id="element-1261" data-mp="kkjf1wbrzmu0">Raleigh-Durham (RDU) Area</option>
                          <option data-id="element-1262" data-mp="fnt23hv9p7ct">Charlotte Area</option>
                          <option data-id="element-1263" data-mp="bl64t1ftuu88">MD / DC Metro</option>
                          <option data-id="element-1264" data-mp="bmh5gsdz7lv4">Other (Enter ZIP)</option>
                        </select>
                      </div>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4" data-id="element-1265" data-mp="13bu5kcdl9xld">
                      <div data-id="element-1266" data-mp="13a974bo5lui8">
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-1267" data-mp="zaic1vrlgs7w">Start Date</label>
                        <div className="relative" data-id="element-1268" data-mp="uc72lm57ojq7">
                          <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1269" data-mp="udrwd9jpbyn0" />
                          <input type="date" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-1270" data-mp="3jymx4ldt4z3s" />
                        </div>
                      </div>
                      <div data-id="element-1271" data-mp="3lieqciuyk9dn">
                        <label className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-1272" data-mp="3lhmud6xg89mu">End Date</label>
                        <div className="relative" data-id="element-1273" data-mp="37i3zhftneush">
                          <CalendarIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1274" data-mp="3bjfpvnkcjk1q" />
                          <input type="date" required className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-[#007a87] focus:outline-none" data-id="element-1275" data-mp="2xrj2txxjc0c7" />
                        </div>
                      </div>
                    </div>

                    <button type="submit" className="w-full bg-[#5a55ea] hover:bg-[#4b47c4] text-white font-bold py-4 rounded-xl transition-colors mt-2 shadow-md text-lg" data-id="element-1276" data-mp="2stha0lab4mnj">
                      Check Availability
                    </button>
                  </form>
                </div>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* Catalog */}
        <section className="py-20" data-id="element-1277" data-mp="2093srkhabigb">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1278" data-mp="1v8fy8otukjhc">
            <div className="text-center mb-12" data-id="element-1279" data-mp="1va9acjn8bvwq">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-1280" data-mp="298qqnwat264m">Premium Equipment Catalog</h2>
              <p className="text-[#5a6a7a] text-lg" data-id="element-1281" data-mp="255157fpfg4nt">Select your gear and book instantly for white-glove delivery.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1282" data-mp="2j3sgyvgthe8s">
              {EQUIPMENT.map((item, idx) => <FadeIn key={item.id} direction="up" delay={0.08 * (idx % 3)} className="h-full" data-id="element-1283" data-mp="2svezlcvhiflk" data-mpi={idx}>
                <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col h-full group" data-id="element-1284" data-mp="2nwu0jgryy1yp">
                  <div className="h-48 overflow-hidden relative bg-gray-100" data-id="element-1285" data-mp="2wxjsg9e3z875">
                    <img src={item.image} alt={item.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-1286" data-mp="2wvfeeymhwst5" />
                    <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-[#007a87]" data-id="element-1287" data-mp="d1v08man8sja">
                      {item.category}
                    </div>
                  </div>
                  
                  <div className="p-6 flex-1 flex flex-col" data-id="element-1288" data-mp="3ljhoykv8kwag">
                    <h3 className="font-bold text-xl text-[#1a2332] mb-4" data-id="element-1289" data-mp="3ll2kacpdkj9d">{item.name}</h3>
                    
                    <div className="flex justify-between items-center mb-6 pb-6 border-b border-gray-100" data-id="element-1290" data-mp="3piqfzhyw6g2b">
                      <div data-id="element-1291" data-mp="3ui33m4xl7r5y">
                        <div className="text-sm text-gray-500" data-id="element-1292" data-mp="35s1zriwxe1m">Daily Rate</div>
                        <div className="font-bold text-lg text-[#1a2332]" data-id="element-1293" data-mp="31v8m9gw2h7wp">{item.daily}</div>
                      </div>
                      <div className="text-right" data-id="element-1294" data-mp="36ttlbczl1ljk">
                        <div className="text-sm text-gray-500" data-id="element-1295" data-mp="36s8t3u0qqeov">Weekly Rate</div>
                        <div className="font-bold text-lg text-[#1a2332]" data-id="element-1296" data-mp="2zaambx9y1hpc">{item.weekly}</div>
                      </div>
                    </div>

                    <div className="flex flex-wrap gap-2 mb-6" data-id="element-1297" data-mp="2pcmubf3q2oav">
                      {item.badges.map((badge, idx) => <span key={idx} className="bg-gray-50 text-gray-600 px-2.5 py-1 rounded-md text-xs font-medium flex items-center gap-1.5 border border-gray-100" data-id="element-1298" data-mp="2lbt3odywavea" data-mpi={idx}>
                          <CheckCircleIcon className="w-3 h-3 text-[#007a87]" data-id="element-1299" data-mp="2bl89r3u62f1p" />
                          {badge}
                        </span>)}
                    </div>

                    <button onClick={() => openModal('rental')} className="mt-auto w-full bg-white border-2 border-[#5a55ea] text-[#5a55ea] hover:bg-[#5a55ea] hover:text-white font-bold py-3 rounded-xl transition-colors flex items-center justify-center gap-2 text-center" data-id="element-1300" data-mp="21n272k0jd4vs">
                      <ShoppingCartIcon className="w-5 h-5" data-id="element-1301" data-mp="1sn5n2vp3cu72" />
                      Book Instantly
                    </button>
                  </div>
                </div>
                </FadeIn>)}
            </div>
          </div>
        </section>

        {/* Delivery & Logistics Explainer */}
        <section className="py-20 bg-white" data-id="element-1302" data-mp="3a0j6gtd6iann">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1303" data-mp="34z3lt2ewy65s">
            <div className="text-center mb-16" data-id="element-1304" data-mp="2h9sv6dra1s5d">
              <h2 className="text-3xl font-bold text-[#1a2332] mb-4" data-id="element-1305" data-mp="2hakdwnzrzve8">How White-Glove Delivery Works</h2>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-1306" data-mp="2ccsqo7a2sxgd">
              <div className="hidden md:block absolute top-12 left-1/4 right-1/4 h-0 border-t-2 border-dashed border-gray-200 z-0" data-id="element-1307" data-mp="2r9jpaebxe54x"></div>
              
              <FadeIn direction="up" delay={0} className="relative z-10 text-center" data-id="element-1308" data-mp="6hho7byflmtd">
                <div className="w-24 h-24 bg-white border-4 border-[#007a87] rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-1309" data-mp="1in3u5ktfq75">
                  <span className="text-3xl font-bold text-[#007a87]" data-id="element-1310" data-mp="91eaqkg2gefu">1</span>
                </div>
                <h3 className="font-bold text-[#1a2332] text-xl mb-3" data-id="element-1311" data-mp="e21xgtx9i949">Book Online</h3>
                <p className="text-[#5a6a7a] leading-relaxed" data-id="element-1312" data-mp="2j10ydtcm7s">Select your gear, dates, and delivery location (home, hotel, or airport).</p>
              </FadeIn>
              
              <FadeIn direction="up" delay={0.1} className="relative z-10 text-center" data-id="element-1313" data-mp="rs5e95ddhamb">
                <div className="w-24 h-24 bg-white border-4 border-[#007a87] rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-1314" data-mp="wrgyiocy6y8n">
                  <span className="text-3xl font-bold text-[#007a87]" data-id="element-1315" data-mp="izu1gmb6llot">2</span>
                </div>
                <h3 className="font-bold text-[#1a2332] text-xl mb-3" data-id="element-1316" data-mp="n0dx1lg3wh8u">SUV Drop-off & Demo</h3>
                <p className="text-[#5a6a7a] leading-relaxed" data-id="element-1317" data-mp="1aqq46u3j29yd">Our logistics team delivers the sanitized equipment and provides a quick operational demo.</p>
              </FadeIn>
              
              <FadeIn direction="up" delay={0.2} className="relative z-10 text-center" data-id="element-1318" data-mp="1pcx6nx3am4vs">
                <div className="w-24 h-24 bg-white border-4 border-[#007a87] rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm" data-id="element-1319" data-mp="1ldodoug2ub1a">
                  <span className="text-3xl font-bold text-[#007a87]" data-id="element-1320" data-mp="1gfd3ujps80j2">3</span>
                </div>
                <h3 className="font-bold text-[#1a2332] text-xl mb-3" data-id="element-1321" data-mp="1bgtgcevjigol">Hassle-Free Pick-up</h3>
                <p className="text-[#5a6a7a] leading-relaxed" data-id="element-1322" data-mp="16hgvu0s55lp6">Leave the gear at your hotel front desk or designated spot, and we'll handle the rest.</p>
              </FadeIn>
            </div>
          </div>
        </section>

        {/* Customer Assurance Section */}
        <section className="py-20 bg-[#1a2332] text-white" data-id="element-1323" data-mp="sp8zga4rrwr0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1324" data-mp="noladu03ppzf">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-1325" data-mp="nqz33w7b6q3t">
              <FadeIn direction="up" delay={0} data-id="element-1326" data-mp="iqbf7jedmpdt">
                <ShieldCheckIcon className="w-12 h-12 text-[#007a87] mx-auto mb-4" data-id="element-1327" data-mp="8m3bugt3ybko" />
                <h3 className="text-xl font-bold mb-3" data-id="element-1328" data-mp="dkxvfkywg45u">5-Minute Sanitization Protocol</h3>
                <p className="text-gray-400" data-id="element-1329" data-mp="dmr5794t74i2">Every item undergoes a rigorous hospital-grade disinfection process before and after every rental.</p>
              </FadeIn>
              <FadeIn direction="up" delay={0.1} data-id="element-1330" data-mp="nils4gg2flqn">
                <BatteryChargingIcon className="w-12 h-12 text-[#007a87] mx-auto mb-4" data-id="element-1331" data-mp="3m0zqdw504t07" />
                <h3 className="text-xl font-bold mb-3" data-id="element-1332" data-mp="3qzu8evv5adj9">Spare Battery Swap</h3>
                <p className="text-gray-400" data-id="element-1333" data-mp="3qxq5oh8zfkkk">Mobility scooters include pre-charged spare batteries to ensure you never lose power on the go.</p>
              </FadeIn>
              <FadeIn direction="up" delay={0.2} data-id="element-1334" data-mp="4l1ds3axg5ka">
                <TruckIcon className="w-12 h-12 text-[#007a87] mx-auto mb-4" data-id="element-1335" data-mp="33a9kdyk4wq34" />
                <h3 className="text-xl font-bold mb-3" data-id="element-1336" data-mp="3385itn9pk360">24/7 Support Hotline</h3>
                <p className="text-gray-400" data-id="element-1337" data-mp="387rys4gx7xii">Need an urgent replacement or have a question? Our local logistics team is on standby 24/7.</p>
              </FadeIn>
            </div>
          </div>
        </section>
      </main>

      <StickyFooter data-id="element-1338" data-mp="18s6u09p2jl7d" />
    </div>;
}